import { FileText, User, Building2, CalendarDays, Coins, Percent, Gift, Clock, RefreshCw, Shield, Camera, BellRing, Users, ListPlus, Trophy, Globe } from "lucide-react";

import { translateFr as tfr } from "@/i18n";
export const CORE_KEYS = ["title", "athlete_name", "counterparty", "start_date", "end_date", "value_amount"];
export const LONG_CLAUSE_KEYS = ["renewal_option", "release_clause", "image_rights", "notice_period", "other_clauses", "signatories"];
export const FOCUSABLE_KEYS = [...CORE_KEYS, "commission_percent", "currency"];
export const CURRENCIES = ["EUR", "USD", "GBP", "CHF"];

const PRIORITY = ["contract_type_hint", "currency", "commission_percent", "signing_bonus", "duration",
  "renewal_option", "release_clause", "image_rights", "notice_period", "sport", "league",
  "effective_date", "signatories", "other_clauses", "title", "athlete_name", "counterparty",
  "start_date", "end_date", "value_amount"];
export const prio = (k) => { const i = PRIORITY.indexOf(k); return i === -1 ? 99 : i; };

export const KEY_ICONS = {
  title: FileText, contract_type_hint: FileText, athlete_name: User, sport: Trophy,
  counterparty: Building2, league: Globe, start_date: CalendarDays, end_date: CalendarDays,
  effective_date: CalendarDays, value_amount: Coins, currency: Coins, commission_percent: Percent,
  signing_bonus: Gift, duration: Clock, renewal_option: RefreshCw, release_clause: Shield,
  image_rights: Camera, notice_period: BellRing, signatories: Users, other_clauses: ListPlus,
};

export const KEY_LABELS_FR = {
  title: tfr("Titre du contrat"), contract_type_hint: "Type de document", athlete_name: tfr("Athlète"),
  sport: "Sport", counterparty: "Contrepartie", league: "Ligue / Championnat",
  start_date: tfr("Date de début"), end_date: "Date de fin", effective_date: "Date d'effet",
  value_amount: "Montant annuel", currency: "Devise", commission_percent: "Commission",
  signing_bonus: tfr("Prime à la signature"), duration: tfr("Durée"), renewal_option: "Option de prolongation",
  release_clause: tfr("Clause libératoire"), image_rights: tfr("Droits à l'image"), notice_period: tfr("Préavis"),
  signatories: "Signataires", other_clauses: "Autres clauses",
};

export const normName = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();

export const parseAmount = (s) => {
  const n = parseFloat(String(s ?? "").replace(/\s|\u202f|\u00a0/g, "").replace(",", ".").replace(/[^\d.-]/g, ""));
  return Number.isFinite(n) ? n : null;
};

export const fmtAmountDisplay = (s, locale) => {
  const n = parseAmount(s);
  return n === null ? "" : new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(n);
};

export const isIsoDate = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || "");

export const valuesDiffer = (key, extracted, current) => {
  if (!extracted || !current) return false;
  if (key === "value_amount") {
    const a = parseAmount(extracted); const b = parseAmount(current);
    return a !== null && b !== null && Math.abs(a - b) >= 0.005;
  }
  return normName(String(extracted)) !== normName(String(current));
};
